import { type BoxProps, Flex } from "@chakra-ui/react";
import React from "react";
import { TableIcon } from "ui/icons";

export function SourceRowItem({ children, ...props }: BoxProps) {
  return (
    <Flex
      flex={2}
      p={{ base: 2, md: 3 }}
      gap={{ base: 1, sm: 2 }}
      align="center"
      bg="base.background"
      borderRadius="6px"
      border="none"
      zIndex={1}
      {...props}
    >
      <TableIcon boxSize={{ base: 4, md: 5 }} />
      {children}
    </Flex>
  );
}
